<template>
  <Card class="w-fit mx-auto px-5 text-center" pt:body:class="p-8!">
    <template #header>
      <p class="text-2xl font-bold pt-3">Accudraw License</p>
      <p v-if="expiration" class="text-md font-bold" :class="getExpirationSeverity()">Expires: {{ format(expiration, "MM/dd/yyyy") }}</p>
    </template>
    <template #content>
      <p>Upload a new valid license</p>
      <FileUploadButton v-model:file="newLicense" accept=".txt"></FileUploadButton>
      <Button class="h-10 w-full mt-4" severity="success" @click="upload">Upload</Button>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { format } from "date-fns";
import { z } from "zod";

const newLicense = ref();
const expiration = ref();

const emit = defineEmits<{
  uploaded: [];
}>();

const getExpirationSeverity = (): string => {
  if (expiration.value === undefined) return "";
  const today = new Date();
  const dayDiff = calculateDays(today, expiration.value);
  if (expiration.value < today) return "text-danger-500";
  else if (dayDiff <= 30) return "text-warning-500";
  else return "text-success-500";
};

const calculateDays = (startDate: Date, endDate: Date): number => {
  const diff = Math.abs(startDate.getTime() - endDate.getTime());
  return Math.ceil(diff / (1000 * 3600 * 24));
};

const upload = (): void => {
  if (newLicense.value == null) {
    error("No License File Selected", "");
    return;
  }

  const data = new FormData();
  data.append("license", newLicense.value);

  axios.post(`/license/upload`, data, { headers: { "Content-Type": "multipart/form-data" } }).then((response) =>
    handleApiResponse(
      response,
      (data: any) => {
        expiration.value = data;
        success("License Updated", "");
        emit("uploaded");
      },
      (errors: ApiError[]) => {
        if (errors.length > 0) error("Error uploading license", errors[0].message);
      }
    )
  );
};

onBeforeMount(async (): Promise<void> => {
  axios.get(`/license/expiration`).then((response) =>
    handleApiResponse(
      response,
      (data: any) => {
        expiration.value = z.coerce.date().parse(data);
      },
      (errors: ApiError[]) => {
        if (errors.length > 0) error("Error Occurred", errors[0].message);
      }
    )
  );
});
</script>
